<template>
    <div>       
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">Create Proposal</h1>
                <div @click="$modal.hide('create-proposal')">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>
            <div class="modal-toolbar h-20 flex items-center justify-between">
                <div class="flex items-center">
                    <label class="mb-0 text-sm font-semibold whitespace-nowrap" for="building_id">For Building:</label>
                    <div class="flex flex-col">
                        <select v-model="proposal.building_id" class="ml-2 form-select">
                            <option value="">Select Building</option>
                            <option v-for="site in projects.selectedProject.sites" :key="site.id" :value="site.id">
                                Existing Site: {{ site.building.address_line_1 }}, {{ site.building.city }}, {{ site.building.state }}
                            </option>
                            <option v-for="comp in compsSortedBy" :key="comp.id" :value="comp.id">
                                Comp: {{ comp.address_line_1 }}, {{ comp.city }}, {{ comp.state }}
                            </option>
                        </select>
                        <div v-if="errors.building_id" class="ml-2 form-error">{{ errors.building_id[0] }}</div>
                    </div>
                </div>  
            </div>  
            <div>
                <form class="px-6 py-4 border bg-gray-50">
                    <div class="px-2 py-3 flex flex-wrap gap-y-6 gap-x-8">
                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="total_square_feet">Rentable Sq. Ft.</label>
                            <number-input name="total_square_feet" v-model="proposal.total_square_feet" classes="text-sm text-right"></number-input>
                            <div v-if="errors.total_square_feet" class="form-error">{{ errors.total_square_feet[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="term">Term (Years)</label>
                            <number-input name="term" v-model="proposal.term" classes="text-sm text-right"></number-input>
                            <div v-if="errors.term" class="form-error">{{ errors.term[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="loss_factor_percentage">Loss Factor (%)</label>
                            <percent-input name="loss_factor_percentage" v-model="proposal.loss_factor_percentage" classes="text-sm text-right"></percent-input>
                            <div v-if="errors.loss_factor_percentage" class="form-error">{{ errors.loss_factor_percentage[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="discount_rate">Discount Rate (%)</label>
                            <percent-input name="discount_rate" v-model="proposal.discount_rate" classes="text-sm text-right"></percent-input>
                            <div v-if="errors.discount_rate" class="form-error">{{ errors.discount_rate[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="include_free_months">Incl. Free Months</label>
                            <select v-model="proposal.include_free_months" class="mt-0 form-select">
                                <option value=""></option>
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                            </select>
                            <div v-if="errors.include_free_months" class="form-error">{{ errors.include_free_months[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="ti_required_psf">TI $ Req. PSF</label>
                            <currency-input name="ti_required_psf" v-model="proposal.ti_required_psf" classes="text-sm text-right" is-decimal></currency-input>
                            <div v-if="errors.ti_required_psf" class="form-error">{{ errors.ti_required_psf[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="ti_offered_psf">TI $ Offered PSF</label>
                            <currency-input name="ti_offered_psf" v-model="proposal.ti_offered_psf" classes="text-sm text-right" is-decimal></currency-input>
                            <div v-if="errors.ti_offered_psf" class="form-error">{{ errors.ti_offered_psf[0] }}</div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="bg-gray-100 p-4">
                <div class="flex items-center justify-end">
                    <button class="btn btn-secondary mr-2" @click.prevent="$modal.hide('create-proposal')">Close</button>
                    <button class="btn btn-green" @click.prevent="createProposal">
                        <span v-if="loading">
                            <inline-svg name="loading-button"></inline-svg>                                
                        </span>
                        <span v-if="! loading">Create Proposal</span>
                    </button>
                </div>
            </div>
        </div>

        <notifications classes="notification" position="bottom right"></notifications>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';

    export default {
        props: {

        },

        data() {
            return {
                proposal: {
                    revision_number: 1
                },
                loading: false
            }
        },

        mounted() {
            this.proposal.project_id = this.projects.selectedProject.id;
        },

        computed: {
            ...mapState(['projects']),
            ...mapState(['proposals']),
            ...mapGetters(['compsSortedBy']),

            errors() {
                return this.proposals.errors;
            }
        },

        methods: {
            createProposal() {
                this.$store.dispatch('createProposal', this.proposal);
            }
        }
    }
</script>